import Vue from "vue";

export default {
  async list() {
    const response = await Vue.axios.get("layers");
    return response.data;
  },

  async get(id) {
    const response = await Vue.axios.get(`layers/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await Vue.axios.post("layers", data);
    return response.data;
  },

  async update(id, data) {
    const response = await Vue.axios.put(`layers/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await Vue.axios.delete(`layers/${id}`);
    return response;
  }
};
